<template>
  <div class="page pyyz">
    <div :class="contentClass">
      <div class="tab-title">
        <img :src="title">
      </div>
      <div class="pyyz-datalist">
        <component
          :is="curretTabName"
          @playVideo="playVideo"
          @showPic="showPic"
        ></component>
      </div>
    </div>

    <div class="btn-submenu" @click="subMenn = true">
      <img :src="iconUrlActive">
      <span :class="ruClass">{{currentTabTitle}}</span>
      <span class="icon-triangle-up"></span>
    </div>
    
    <transition name="submenu-slide">
      <div class="submenu-wrapper" v-if="subMenn">
        <div class="pyyz-menu">
          <BottomNav
            :page="page"
            :items="tabs"
            :active="currentTab"
            btnclass="pyyz-nav"
            class="pyyz-tabnav"
            :class="ruClass"
            :icon="{iconUrlDefault, iconUrlActive}"
            @changeNav="changeTab"
          ></BottomNav>
          <div class="btn-dialog" @click="subMenn = false">{{ $t("base.pack-up") }}</div>
        </div>
      </div>
    </transition>

    <VideoPlay
      :info="videoData"
      v-if="videoPlayer"
      @closePlayer="videoPlayer = false"
    ></VideoPlay>

    <PicShow
      :pic="picData"
      v-if="picPage"
      @close="picPage = false"
    ></PicShow>
  </div>
</template>

<script>
import { mapState } from "vuex";

import BottomNav from "@/components/BottomNav.vue";
import Graphic from './Graphic';
import Animation from './Animation';
import Pianhua from './Pianhua';
import Games from './Games';
import Stamp from './Stamp';
import Ringtone from './Ringtone';
import Emoji from './Emoji';
import Documentary from './Documentary';
import VideoPlay from "@/components/VideoPlay";
import PicShow from './PicShow';

import iconUrlDefault from "@/assets/img/tab4-d.png";
import iconUrlActive from "@/assets/img/tab4-a.png";

export default {
  components: {
    BottomNav,
    "m-graphic": Graphic,
    "m-animation": Animation,
    "m-pianhua": Pianhua,
    "m-games": Games,
    "m-stamp": Stamp,
    "m-ringtone": Ringtone,
    "m-emoji": Emoji,
    "m-documentary": Documentary,
    VideoPlay,
    PicShow
  },
  data() {
    return {
      page: "pyyz",
      currentTab: 0,
      subMenn: false,
      iconUrlDefault,
      iconUrlActive,
      videoPlayer: false,
      videoData: {},
      picPage: false,
      picData: {}
    };
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs.pyyz,
      localr: "locale"
    }),
    title() {
      return this.tabs[this.currentTab].ttimg;
    },
    curretTabName() {
      const tabName = this.tabs[this.currentTab].name;
      return tabName ? `m-${tabName}` : "";
    },
    currentTabTitle() {
      const tabName = this.tabs[this.currentTab].name;
      return tabName ? this.$t(`tabs.${this.page}.${tabName}`) : "";
    },
    contentClass() {
      return `${this.page}-tabs`;
    },
    ruClass() {
      return this.localr === "ru" ? "ru-menu" : "";
    }
  },
  mounted() {},
  methods: {
    changeTab(activeNum) {
      this.currentTab = activeNum;
      this.subMenn = false;
    },
    playVideo(data) {
      this.videoData = data;
      this.videoPlayer = true;
    },
    showPic(data) {
      this.picData = data;
      this.picPage = true;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/base";
.pyyz-tabs {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 80vh;

  .tab-title {
    height: 3rem;
    padding-top: 0.5rem;
    text-align: center;

    img {
      max-height: 100%;
    }
  }
}

.pyyz-datalist {
  flex: 1;
  padding-top: 1rem;

  .data-list {
    height: 70vh;

    &.hasSubtab {
      height: 60vh;
    }

    .text-main {
      padding: 0;
    }
  }

  .subtab {
    display: flex;
    justify-content: center;
    padding-bottom: 1rem;

    .subtab-item {
      padding: 2px 10px;
      margin: 0 5px;
      color: $text;
      font-size: 0.875rem;
      font-weight: 700;
      border-radius: 3px;

      &.active {
        background-color: $primary;
        color: $text-dark;
      }
    }
  }
}

.btn-submenu {
  position: absolute;
  bottom: 1rem;
  @include center-x;
  white-space: nowrap;

  img {
    display: inline-block;
    width: 0.65rem;
    height: 0.65rem;
    margin-right: 0.75rem;
  }

  span {
    display: inline-block;
    font-size: 0.875rem;
    font-weight: 700;
    color: $primary;

    &::after {
      content: "";
      display: block;
      height: 1px;
      background-color: $primary;
    }

    &.ru-menu {
      font-weight: 500;
    }
  }

  .icon-triangle-up {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.75rem;
    border-width: 0.35rem;
    border-style: solid;
    border-color: transparent transparent $primary transparent;
  }
}

.submenu-wrapper {
  .pyyz-menu {
    position: relative;
    height: 100%;
    padding-top: 3rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    background-image: url("~@/assets/img/dialog-bg.jpg");
    background-size: 100%;
  }
  .pyyz-tabnav {
    flex-direction: column;
    bottom: initial;
  }
  .pyyz-nav {
    height: 2.5rem;
    text-align: left;
    white-space: nowrap;

    .icon {
      display: inline-block;
      width: 0.75rem;
      height: 0.75rem;
      margin-right: 0.5rem;
    }

    span {
      display: inline-block;
      vertical-align: top;
    }

    &:focus,
    &:active {
      span {
        color: $primary;
      }
    }

    &.active {
      &::after {
        display: none;
      }
      span::after {
        content: "";
        display: block;
        height: 1px;
        background-color: $primary;
      }
    }
  }
  .ru-menu {
    span {
      font-weight: 500;
    }
  }
}


</style>
